<mh-dashboard-widget-card [ready]="ready()">
  <mh-chart-value-widget
    [title]="'interchain-dashboard.widgets.sentiment_index.title' | translate"
    [subtitle]="'interchain-dashboard.widgets.sentiment_index.subtitle' | translate"
    [description]="rawData()?.description"
    [percentage]="true"
    [product]="'semantic'"
    [enabled]="enabled()"
    [value]="displayValue()"
    [loading]="loading()"
    [error]="error()"
    [changePercentage]="changePercentage()"
    [increase]="isIncrease()"
    [chartData]="chartData()"
    [chartOptions]="chartOptions()"
    [route]="'/sentiment/summary'"
  />
</mh-dashboard-widget-card>
